import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * Wraps protected routes. Reads the JWT from the Zustand auth store; if
 * absent, redirects to /login while remembering the original path so the
 * post-login redirect can return the user to where they were trying to go.
 *
 * The user object itself is fetched lazily by /auth/callback (after OAuth)
 * or by the dashboard layout's me-query. AuthGuard only checks the token —
 * it doesn't block on the user payload, so the dashboard can render its
 * skeleton while /api/auth/me is in flight.
 */
export function AuthGuard() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
